// extracted by mini-css-extract-plugin
module.exports = {"shareGroup":"src-components-Share-Group-styles-style-module__shareGroup--1BEYn"};